import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  Printer,
  ShoppingCart,
  Users,
  Factory,
  Percent,
  LogOut,
  Layers,
  ShoppingBag,
  QrCode,
  BarChart3,
  Award,
  Settings,
  ChevronRight
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/useAuth';
import { useState } from 'react';

const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
  { icon: Package, label: 'Produtos', path: '/admin/produtos' },
  { icon: Percent, label: 'Categorias', path: '/admin/categorias' },
  { icon: Layers, label: 'Filamentos', path: '/admin/insumos/filamentos' },
  { icon: ShoppingBag, label: 'Insumos Gerais', path: '/admin/insumos/embalagens' },
  { icon: Printer, label: 'Máquinas', path: '/admin/maquinas' },
  { icon: Factory, label: 'Produção', path: '/admin/producao' },
  { icon: ShoppingCart, label: 'Pedidos', path: '/admin/pedidos' },
  { icon: BarChart3, label: 'Financeiro / BI', path: '/admin/bi' },
  { icon: Award, label: 'Fort3D Club', path: '/admin/fidelidade' },
  { icon: ShoppingBag, label: 'Marketplace', path: '/admin/marketplaces' },
  { icon: QrCode, label: 'Tags de Unboxing', path: '/admin/unboxing' },
  { icon: Users, label: 'Clientes', path: '/admin/clientes' },
  { icon: Percent, label: 'Cupons', path: '/admin/cupons' },
  { icon: Settings, label: 'Configurações', path: '/admin/configuracoes' },
];

export function Sidebar() {
  const location = useLocation();
  const { logout, user } = useAuth();
  const [isCollapsed] = useState(false);

  return (
    <aside 
      className={cn(
        "fixed left-0 top-0 z-40 h-screen bg-white border-r border-gray-200 transition-all duration-300",
        isCollapsed ? "w-20" : "w-64"
      )}
    >
      <div className="flex h-full flex-col">
        {/* Logo */}
        <div className="flex h-16 items-center px-6 border-b border-gray-100">
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="w-8 h-8 flex items-center justify-center">
              <img src="/images/branding/icon.png" alt="Icon" className="h-7 w-7 object-contain" />
            </div>
            {!isCollapsed && (
              <span className="text-xl font-black text-gray-900 tracking-tight">Fort<span className="text-fort3d-laranja">3D</span></span>
            )}
          </div>
        </div>

        {/* Menu */}
        <nav className="flex-1 space-y-1 px-3 py-4 overflow-y-auto">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path || 
              (item.path !== '/admin' && location.pathname.startsWith(item.path));
            
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={cn(
                  'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                <item.icon className={cn("h-5 w-5 flex-shrink-0", isActive ? "text-primary" : "text-gray-400")} />
                {!isCollapsed && (
                  <>
                    <span className="flex-1">{item.label}</span>
                    {isActive && <ChevronRight className="h-4 w-4" />}
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="border-t border-gray-100 p-4">
          <div className={cn("flex items-center gap-3 mb-4", isCollapsed && "justify-center")}>
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-primary-600 flex items-center justify-center text-white font-medium">
              {user?.nome?.charAt(0) || 'U'}
            </div>
            {!isCollapsed && (
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">{user?.nome || 'Usuário'}</p>
                <p className="text-xs text-gray-500">{user?.role || 'Admin'}</p>
              </div>
            )}
          </div>
          
          <button
            onClick={logout}
            className={cn(
              "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors w-full",
              isCollapsed && "justify-center"
            )}
          >
            <LogOut className="h-5 w-5 text-gray-400" />
            {!isCollapsed && <span>Sair</span>}
          </button>
        </div>
      </div>
    </aside>
  );
}
